import { BreadcrumbJsonLd } from 'next-seo';

import { getPathWithDomain } from '@/utils/router.utils';

interface Props {
  data: {
    path?: string;
    name: string;
  }[];
}

export const BreadcrumbsStructuredData = (props: Props) => {
  const { data } = props;

  const itemListElements = data.map((item, index) => ({
    position: index + 1,
    name: item.name,
    item: getPathWithDomain(item.path),
  }));
  return <BreadcrumbJsonLd itemListElements={itemListElements} />;
};
